export default __webpack_public_path__ + "static/media/default-image.520770ad.png";